// i18n
import en from './en.json' // 存放英文翻譯
import cn from './zh-Hans.json' // 存放簡體中文翻譯
import hk from './zh-Hant.json' // 存放繁體中文翻譯
import th from './th.json' // 存放泰文翻譯
import vn from './vn.json' // 存放越南文翻譯
import id from './id.json' // 存放印尼文翻譯
import kr from './kr.json' // 存放韓文翻譯
import ja from './ja.json' // 存放日文翻譯
import pt from './pt.json' // 存放葡萄牙文翻譯
import es from './es.json' // 存放西班牙文翻譯
import bn from './bn.json' // 存放孟加拉文翻譯
import hi from './hi.json' // 存放印度文翻譯
import fr from './fr.json' // 存放法文翻譯
import { vsprintf } from 'sprintf-js'
import { getUrlLang } from '@/plugins/common'

// http://www.lingoes.net/en/translator/langcode.htm
// 瀏覽器語系匹配
const locales = {
  'zh_hk': hk,
  'zh_cn': cn,
  'en_us': en,
  'th_th': th,
  'vi_vn': vn,
  'id_id': id,
  'ko_kr': kr,
  'ja_jp': ja,
  'pt_pt': pt,
  'es_es': es,
  'bn_bd': bn,
  'hi_in': hi,
  'fr_fr': fr
}

// 中文語系檔  key <=> value互換
var chart = {}
Object.keys(hk).forEach((key) => {
  chart[hk[key]] = key
})

export default {
  data() {
    return {
      locales: locales,
      chart: chart
    }
  },
  methods: {
    $ln: function(params, ...args) {
      let str = ''
      const show = process.env.VUE_APP_LANGUAGE_SHOW
      if (typeof (params) === 'undefined' || params === '') return '' // 空值

      /**
       * 檢查語系
       * 1.檢查瀏覽器語系代碼是否存在
       * 2.檢查localStorage  key=i18n是否存在
       * 3.檢查store是否存在
       */
      const store = this.$store.state.app.language // 必要為了觸發rander
      let i18n = getUrlLang()
      i18n = (this.locales[store]) ? store : i18n

      // get key
      const key = this.chart[params] ? this.chart[params] : params

      if (show === 'false') { // 關閉語系時候預設英文
        str = this.locales['en_us'][key]
      } else {
        str = this.locales[i18n][key] ? this.locales[i18n][key] : '@語系:' + key + '@'
      }
      str = (args.length > 0) ? vsprintf(str, args) : str
      return str
    }
  }
}
